import path from 'path';

export const BASE = '/rental-manager/applications';
export const RENTAL_MANAGER_WEB = '/rental-manager/properties';
export const LOGIN = '/user/acct/login';

export const TERMS = path.join(BASE, 'terms');
export const ID_VERIFICATION = path.join(BASE, 'id-verification');
export const FAVICON = '/favicon.ico';
export const LANDLORD_REVIEW = path.join(BASE, '/:applicationId');
export const GRAPHQL = path.join(BASE, 'graphql');
export const MISSING_PERMISSIONS = path.join(BASE, 'missing-permissions');
export const FAILED_REQUEST = path.join(BASE, 'failed-request');
export const LOG = path.join(BASE, 'log');
export const SHARE = path.join(BASE, '/share/:shareId');
export const ZILLOW_TENANT_SCREENING_SERVICES = path.join(BASE, 'tenant-screening-services');
export const ZTSS_LANDING = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'landing');
export const ZTSS_DASHBOARD = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'applications');
export const ZTSS_PROPERTIES = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'addresses');
export const ZTSS_ENTER_YOUR_NAME = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'enter-your-name');
export const ZTSS_ENTER_YOUR_ADDRESS = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'enter-your-address');
export const ZTSS_INVITE_A_RENTER = path.join(ZILLOW_TENANT_SCREENING_SERVICES, 'invite-a-renter');
